export default function SellerInfo({ data }) {
  return (
    <div className="mb-2 rtl">
      <div className="d-flex flex-wrap flex-column flex-sm-row gap-2 align-items-center justify-content-between bg-white shadow rounded px-4 py-4 text-center">
        <div className="d-flex align-items-center me-3 border-rad">
          <span className="fw-semibold text-dark">
            {data.seller.sellerName}
          </span>
        </div>
        <div className="d-flex align-items-center me-3 border-rad">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="1.4em"
            height="1.4em"
          >
            <path
              fill="#212529"
              d="M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4zm-6 4h-4v-4h4z"
            ></path>
          </svg>
          <span className="fw-semibold text-dark" id="seller_id">
            {data.seller.sellerId}
          </span>
        </div>
        <div className="me-3 d-flex align-items-center">
          <span className="fw-semibold text-dark" id="full_name">
            {data.seller.fullName}
          </span>
        </div>
        <div className="d-flex align-items-center">
          <span className="p-1">وضعیت</span>

          <div id="statusBadge">
            <span className="badge bg-success p-2 text-white rounded">
              فعال
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
